import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  LineChart,
  ChartFooterV2
} from '@/modules/common/components/charts/v2';
import { HelperViewStatus } from '@warrenbrasil/nebraska-web';

import {
  PortfolioChartAxisX,
  PortfolioChartAxisY,
  PortfolioChartAxisYValues,
  PortfolioChartFilter
} from '@/modules/wealth/services/portfolio';

interface Props {
  axisX: PortfolioChartAxisX[];
  axisY: PortfolioChartAxisY[];
  benchmarkFilters: PortfolioChartFilter[];
  updatedAt?: string;
  isLoading?: boolean;
  hasError?: boolean;
  height?: string;
}
interface Emits {
  (e: 'on-animation-state-change', value: boolean): void;
  (e: 'on-retry'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceChart',
  props: {
    axisX: null,
    axisY: null,
    benchmarkFilters: null,
    updatedAt: { default: '' },
    isLoading: { type: Boolean },
    hasError: { type: Boolean },
    height: { default: '400px' }
  },
  emits: ["on-animation-state-change", "on-retry"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-animation-state-change', value: boolean): void;
  (e: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { axisX: PortfolioChartAxisX[], axisY: PortfolioChartAxisY[], benchmarkFilters: PortfolioChartFilter[], updatedAt: string, isLoading?: boolean, hasError?: boolean, height: string };





const portfolioData = computed(() => {
  const portfolio = props.axisY?.find(
    axis => axis.type === PortfolioChartAxisYValues.Portfolio
  );
  const profit = props.axisY?.find(
    axis => axis.type === PortfolioChartAxisYValues.Profit
  );

  return {
    name: portfolio?.name || '-',
    data: portfolio?.values.map(value => (value ? value.value : null)) || [],
    comparator:
      profit?.values.map(value => (value ? value.formatted : null)) || [],
    benchmarkComparison:
      portfolio?.values.map(value =>
        value ? value.benchmarkComparison : null
      ) || []
  };
});

const benchmarkData = computed(() => {
  const benchmark = props.axisY?.find(
    axis => axis.name === activeBenchmarkFilter.value?.label
  );

  return {
    name: activeBenchmarkFilter.value?.summaryLabel || '-',
    data: benchmark?.values.map(value => (value ? value.value : null)) || []
  };
});

const range = computed(() => {
  const startDate = props.axisX?.[0]?.range?.start?.formatted;
  const endDate = props.axisX?.[0]?.range?.end?.formatted;

  return startDate && endDate ? `${startDate} a ${endDate}` : '-';
});

const labels = computed(() => {
  return props.axisX?.[0]?.values?.map(value => value.value) || [];
});

const activeBenchmarkFilter = computed(() => {
  return props.benchmarkFilters.find(filter => filter.active);
});

const handleOnAnimationStateChange = (value: boolean) => {
  emit('on-animation-state-change', value);
};

const emitRetry = () => {
  emit('on-retry');
};

return { __sfc: true,props, emit, portfolioData, benchmarkData, range, labels, activeBenchmarkFilter, handleOnAnimationStateChange, emitRetry, LineChart, ChartFooterV2, HelperViewStatus }
}

})